// extracted by mini-css-extract-plugin
export default {"wrapper":"NotePage_wrapper__L6I3z"};